/**
 * Created by rkotha on 8/18/2017.
 */
<!-- This state executes user logs in-->
(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('user-home-page', {
            parent: 'app',
            url: '/userhomepage',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/user-home-page/user-home-page.html',
                    controller: 'UserHomePageController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('userhomePage');
                    return $translate.refresh();
                }],
                contactEntities: ['$stateParams', 'NasracWebContent', function($stateParams, NasracWebContent) {
                    return NasracWebContent.getPage({page : 'arrisAccountContacts'}).$promise;
                }],
                announcementsEntities:['$stateParams', 'NasracWebContent', function($stateParams, NasracWebContent) {
                    return NasracWebContent.getPage({page : 'importantAnnouncements'}).$promise;
                }]


            }
        });
    }
})();
